<template lang="pug">
  LayoutDefault
    .page: .container-fluid
      .section: .card: .card--body
        .heading--section E-Payment
        .pad_t--20
          MessageBar(:type="notificationState", :withIcon="true", :icon="notificationIcon")
            | <strong v-if="data.TxnMessage" class="bold__semi">{{ data.TxnMessage }}.</strong> {{ notificationMsg }}
        
        .row.pad_t--35
          .col-5.text--color_grey
            .msg-box
              template(v-if="data.TxnStatus === '0'")
                p Your payment of {{ data.CurrencyCode }} {{ data.Amount }} has been received. You will receive confirmation email at {{ data.CustEmail }} shortly.
                p You can make another E-Payment or check the <router-link to="/payment/status">payment status</router-link>.


              template(v-else)
                p There was an error whilst making your FPX payment. <strong>The payment have not been recieved</strong>.
                p You can make another E-Payment or check the <router-link to="/payment/status">payment status</router-link>.

              router-link(to="/payment/ePayment" class="btn btn-primary btn-sm")
                i.fa.fa-donate.mr-3
                span.btn__standard Make another E-Payment

          .col-7
            FPXTnC

</template>



<script>
import requestHandlers from '../mixins/requestHandlers';
import MessageBar from '../components/MessageBar';
import FPXTnC from '../components/FPXTnC';

export default {
  name: 'EghlCallback',
  mixins: [requestHandlers],
  components: {
    MessageBar,
    FPXTnC
  },

  data() {
    return {
      data: {}, // TxnStatus // CurrencyCode // Amount // PaymentID // CustName // CustEmail // TxnMessage
    }
  },

  computed: {
    notificationIcon() {
      let { TxnStatus } = this.data;
      let _icon = "check-circle";

      if(TxnStatus !== '0') {
        _icon = "exclamation-circle";
      }

      return _icon;
    },


    notificationState() {
      let { TxnStatus } = this.data;
      let _state = "success";

      if(TxnStatus !== '0') {
        _state = "error";
      }

      return _state;
    },


    notificationMsg() {
      let { TxnStatus, CurrencyCode, Amount } = this.data;

      let isPaymentSuccesful = TxnStatus === '0';

      let _msg = '';

      if(isPaymentSuccesful && CurrencyCode && Amount) {
        _msg = `Payment successfully sent.`

      } else {
        _msg = 'Payment is not successful.';
      }

      return _msg;
    }
  },

  methods: {
  },

  created() {
    this.data = this.$route.query;
  },
}

</script>




<style lang="scss">
  .msg-box {
    background: #f3f3f3;
    padding: 20px 15px 20px;
  }
</style>
